<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav>
        <h4 class="mb-0">{{title}}</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-row>
          <b-col cols="auto">
            <b-button id="table-settings" size="sm" variant="warning" class="mr-2" v-b-toggle.sidebar-fields>
              <font-awesome-icon icon="cog"/>
            </b-button>
            <b-tooltip target="table-settings" triggers="hover" variant="warning" noninteractive>
              Колонки
            </b-tooltip>
            <b-btn v-if="canEditRecruitJobPostings()" size="sm" variant="success" :disabled="isBusy" @click="showModal(null, false)">
              <font-awesome-icon icon="plus" class="mr-1"/>
              Новая
            </b-btn>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <filters-drawer
      :query.sync="filters.query"
      :is-busy="isBusy"
      :filter-tags="activeFilterTags"
      @remove-tag="removeFilterTag"
      @submit="onSearch"
      @clear="onClearFilters"
    >
      <b-col md="6" cols="12" class="mt-1">
        <label class="small text-muted">Объявления</label>
        <recruit-job-posting-select
          ref="recruit_job_posting_select"
          title="id объявления"
          @onSelect="onSelectJobPosting"
        />
      </b-col>
      <b-col cols="12" class="mt-1">
        <label class="small text-muted">Ответственные</label>
        <user-multi-select
          id="user-multi-select-assigned"
          ref="user_multi_select_assigned"
          title="Ответственные"
          @onSelect="onSelectUserAssigned"
        />
      </b-col>
<!--   TODO: recruit_task_id   -->
<!--  TODO: каталог status
      <b-col md="6" cols="12" class="mt-1">
        <label class="small text-muted">Статус</label>
        <b-form-select
          id="input-statuses"
          size="sm"
          v-model="filters.status"
          :options="statusOptions"
        />
      </b-col>
-->
<!--   TODO: worker_id  -->
    </filters-drawer>

    <b-table
      v-if="viewMode === 'table'"
      id="job-posting-responses"
      ref="job_posting_responses"
      class="mb-0 text-small"
      selectable
      select-mode="single"
      selectedVariant="success"
      striped
      small
      responsive
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy.sync="isBusy"
      :items="items"
      :fields="renderedFields"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
      no-local-sorting
      @sort-changed="sortChanged"
      @row-dblclicked="onRowClicked"
      sticky-header
      head-variant="light"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"/>
          <strong>Загрузка</strong>
        </div>
      </template>

      <template #cell(fits)="row">
        <template v-if="row.item.fits">
          <font-awesome-icon icon="check-circle" class="text-success"/>
        </template>
        <template v-else>
          <font-awesome-icon icon="times-circle" class="text-danger"/>
        </template>
      </template>

      <template #cell(recruit_task_id)="row">
        <b-link @click.stop="showModalRecruitTask(row.item.recruit_task_id)">
          {{ row.item.recruit_task_id }}
        </b-link>
      </template>

      <template #cell(job_posting_id)="row">
        <b-link @click.stop="showModalJobPosting(row.item.job_posting_id)">
          {{ row.item.job_posting_id }}
        </b-link>
      </template>

      <template #cell(id)="row">
        <b-link @click.stop="onRowClicked(row.item)">
          {{ row.item.id }}
        </b-link>
      </template>

      <template #cell(assigned)="row">
        <span v-if="row.item.assigned">
          {{ getAssignedName(row.item.assigned) }}
        </span>
        <b-button
          v-else
          size="sm"
          variant="success"
          class="py-0 px-2"
          @click.stop="takeAssignment(row.item)"
        >
          Взять
        </b-button>
      </template>

      <template #cell(status)="row">
        {{ getStatusText(row.item.status) }}
      </template>

      <template #cell(start_date)="row">
        {{formatTableDate(row.item.start_date)}}
      </template>

      <template #cell(action)="row">
        <b-button-group>
          <b-button v-if="canEditWorkers()" :disabled="row.item.worker_id !== null" class="mr-1" size="sm" variant="info" v-b-tooltip.hover.v-info title="Создать исполнителя из отклика" @click.stop="showModalWorker(row.item)">
            <font-awesome-icon icon="plus"/>
          </b-button>
          <!-- TODO: ban -->
          <b-button v-if="canEditRecruitJobPostings()" variant="danger" @click="onRemove(row)" size="sm" v-b-tooltip.hover.v-danger title="Удалить отклик">
            <font-awesome-icon icon="ban"/>
          </b-button>
        </b-button-group>
      </template>
    </b-table>

    <pagination-footer
      :total-rows="totalRows"
      :per-page.sync="perPage"
      @page-click="onPagination"
      @per-page-change="onPerPageChange"
    />

    <DynamicTables
      storage-key="jobPostingResponses_columns"
      sidebar-fields="sidebar-fields"
      :fields-model.sync="fields"
      :serviceEndField="serviceEndField"
      fieldKey="id"
    />

    <JobPostingResponse ref="job_posting_response" @refresh="getItems" @modal-closed="onModalClosed"/>

    <recruit-task ref="modal_recruit_task" :is-integrated="true"/>

    <RecruitJobPosting ref="modal_recruit_job_posting"/>

    <b-modal
      ref="modal_worker"
      body-class="p-0"
      title="Создание нового исполнителя"
      size="xl"
    >
      <Worker
        ref="worker_component"
        :is-modal="true"
        :response-id="responseId"
        @refresh="onWorkerSaved"
        @close-modal="onModalWorkerClosed"
      />
      <template #modal-footer="{}">
          <div class="justify-content-end m-0 p-0">
            <b-button size="sm" variant="secondary" class="mr-1" @click="onModalWorkerClosed()">Отмена</b-button>
            <b-button size="sm" variant="success" @click="handleSubmitModalWorker()">Сохранить</b-button>
          </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import recruitJobPostings from "../../network/recruitJobPostings";
import catalogs from "../../network/catalogs";
import users from "../../network/users";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import DynamicTables from "../../utilites/commonUi/DynamicTables.vue";
  import FiltersDrawer from "../../utilites/commonUi/FiltersDrawer.vue";
  import permissions, {PERM} from "../../utilites/permissions";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";
    import LocationMultiSelect from "../Locations/LocationMultiSelect.vue";
    import UserMultiSelect from "../Users/UserMultiSelect.vue";
    import JobPostingResponse from "./JobPostingResponse.vue";
    import RecruitTask from "./RecruitTask.vue";
    import RecruitJobPosting from "./RecruitJobPosting.vue";
    import Worker from "../Workers/Worker.vue";
    import RecruitJobPostingSelect from "./RecruitJobPostingSelect.vue";

export default {
  name: "RecruitJobPostings",
  components: {
    RecruitJobPostingSelect, Worker, RecruitJobPosting, RecruitTask, PaginationFooter, FiltersDrawer, JobPostingResponse, UserMultiSelect, LocationMultiSelect, DynamicTables },
  mixins: [
    recruitJobPostings, catalogs, users,
    helpers, dateFormatter, permissions, pageSearchService
  ],
  data() {
    return {
      title: 'Отклики',
      items: [],
      usersList: [],
      sortBy: 'id',
      sortDesc: true,
      userId: null,
      serviceStartField: {
        key: 'fits',
        label: '',
        class: 'text-center',
      },
      fields: [
        {
          key: 'id',
          label: 'id кандидата',
          class: 'text-center',
          sortable: true,
          visible: true,
        },
        {
          key: 'recruit_task_id',
          label: 'id заявки',
          class: 'text-center',
          sortable: true,
          visible: true,
        },
        {
          key: 'job_posting_id',
          label: 'id объявления',
          class: 'text-center',
          sortable: true,
          visible: true,
        },
        {
          key: 'location_vacancy_name',
          label: 'Вакансия',
          sortable: true,
          visible: true,
        },
        {
          key: 'location_name',
          label: 'Объект',
          sortable: true,
          visible: true,
        },
        {
          key: 'assigned',
          label: 'Рекрутер',
          class: 'text-center',
          sortable: true,
          visible: true,
        },
        /* TODO: каталог статусов
        {
          key: 'status',
          label: 'Статус',
          sortable: true,
          visible: true,
        },
         */
        // TODO: start_date переименовать
        {
          key: 'start_date',
          label: 'Дата отклика',
          class: 'text-center',
          sortable: true,
          visible: true,
        },
        /* TODO: авито интеграция
        {
          key: 'provider_name',
          label: 'Сервис',
          sortable: true,
          visible: true,
        },
         */
      ],
      serviceEndField: {
        key: 'action',
        label: 'Действия',
        class: 'jobPostingResponsesAction',
      },
      isBusy: false,
      filters: this.getDefaultFilters(),
      statusOptions: [
        { value: null, text: 'Все статусы' },
        { value: 'new', text: 'Новый' },
        { value: 'in_progress', text: 'В работе' },
        { value: 'published', text: 'Опубликовано' },
        { value: 'canceled', text: 'Отменено' },
        { value: 'done', text: 'Готово' },
      ],
      providerOptions: [
        { value: null, text: 'Все сервисы' },
        { value: 1, text: 'Авито' },
        { value: 2, text: 'HH' },
      ],
      viewMode: 'table',
      deleteRow: {
        id: null,
      },
      responseId: null,
    }
  },
  async mounted() {
    await this.configureRefs();
  },
  async created() {
    this.isBusy = true;
    const query = this.$route.query;

    if (query) {
      if (query.query) this.filters.query = query.query;

      if (query.job_posting_id) {
        this.filters.job_posting_id = query.job_posting_id;
      }

      if (query.assigned) {
        const decodeLoc = decodeURIComponent(query.assigned);
        this.filters.assigned = decodeLoc.split(",");
      }

      if (query.status) {
        this.filters.status = query.status;
      }
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    this.usersList = (await this.getUsersSearch({})).data.items;
    this.userId = (await this.getUserInfo({})).data.id;

    await this.onSearch();
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible);
    },
    renderedFields() {
      return [
        this.serviceStartField,
        ...this.visibleFields,
        this.serviceEndField
      ];
    },
    activeFilterTags() {
      const tags = [];
      const defaults = this.getDefaultFilters();

      if (this.filters.job_posting_id) {
        tags.push({ key: 'job_posting_id', label: `Id объявления: ${this.filters.job_posting_id}` });
      }

      if (this.filters.assigned.length > 0) {
        tags.push({ key: 'assigned', label: `Рекрутеры: ${this.filters.assigned.length}`,});
      }

      if (this.filters.status !== defaults.status) {
        const foundItem = this.statusOptions.find(s => s.value === this.filters.status);
        tags.push({ key: 'status', label: foundItem ? foundItem.text : 'Статус заявки' });
      }

      return tags;
    },
  },
  watch: {
    '$route.params.id': {
      handler(newId) {
        this.$nextTick(() => {
          if (newId && this.$refs.job_posting_response) {
            const isViewonly = this.$route.query.mode === 'view';
            this.$refs.job_posting_response.showModal(newId, isViewonly);
          } else if (!newId && this.$refs.job_posting_response) {
            this.$refs.job_posting_response.hideModal();
          }
        });
      }, immediate: true
    },
  },
  methods: {
    async takeAssignment(item) {
      item.assigned = this.userId;

      const result = await this.putResponse(item);

      if (result && !result.error) {
        this.showToast('Вы успешно взяли отклик в работу.', 'Успех', 'success');
      } else {
        this.showError('Ошибка');
      }
      await this.getItems();
      this.isBusy = false;
    },
    async getItems() {
      const data = {
        query: this.filters.query,
        page: this.currentPage,
        size: this.perPage,
        job_posting_id: this.filters.job_posting_id,
        assigned: this.filters.assigned,
        status: this.filters.status,
        sortBy: [this.sortBy],
        sortDesc: [this.sortDesc],
      }

      this.isBusy = true;
      const result = await this.getResponses(data);
      this.isBusy = false;

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.items = [];
        this.totalRows = 0;
        this.isBusy = false;
        return;
      }

      this.items = result.data.items;
      this.totalRows = result.data.total;
      this.isBusy = false;
    },
    showModal(responseId, isViewonly) {
      const canEdit = this.canEditRecruitJobPostings();

      if (!responseId) {
        if (!canEdit) return;

        this.$refs.job_posting_response.showModal(null, false);
        return;
      }

      const isView = isViewonly || !canEdit;
      const query = isView ? { mode: 'view' } : {};

      this.$router.push({
        name: 'JobPostingResponses',
        params: { id: responseId },
        query: query
      });
    },
    showModalRecruitTask(recruitTaskId) {
      if (!recruitTaskId) return;

      const canEdit = this.canEditRecruitTasks();
      const isViewonly = !canEdit;

      this.$refs.modal_recruit_task.showModal(recruitTaskId, isViewonly);
    },
    showModalJobPosting(jobPostingId) {
      if (!jobPostingId) return;

      const canEdit = this.canEditRecruitJobPostings();
      const isViewonly = !canEdit;

      this.$refs.modal_recruit_job_posting.showModal(jobPostingId, isViewonly);
    },
    showModalWorker(item) {
      this.responseId = item.id;
      console.log(this.responseId);
      this.$refs.modal_worker.show();

      this.$nextTick(() => {
        if (this.$refs.worker_component) {
          this.$refs.worker_component.configure(item);
        }
      });
    },
    onModalWorkerClosed() {
      this.responseId = null;
      this.$refs.modal_worker.hide();
    },
    async handleSubmitModalWorker() {
      if (this.$refs.worker_component) {
       await this.$refs.worker_component.handleSubmit();
      }
    },
    async onWorkerSaved() {
      this.$bvToast.toast('Исполнитель успешно добавлен.', {
        title: 'Успех',
        variant: 'success',
        autoHideDelay: 3000,
        solid: true
      });
      await this.getItems();
      this.onModalWorkerClosed();
    },
    onRowClicked(row) {
      this.showModal(row.id, false);
    },
    onModalClosed() {
      if (this.$route.params.id) {
        this.$router.replace({
          name: 'JobPostingResponses',
          params: { id: null },
          hash: this.$route.hash,
        }).catch(()=>{});
      }
    },
    getAssignedName(userId) {
      if (!userId) return null;

      const user = this.usersList.find(u => u.id === userId);
      if (!user) { return '' }
      return user.name;
    },
    getStatusText(statusValue) {
      const option = this.statusOptions.find(opt => opt.value === statusValue);
      return option.text;
    },
    // Filters
    getDefaultFilters() {
      return {
        query: '',
        status: null,
        assigned: [],
      };
    },
    async onClearFilters() {
      const filters = this.getDefaultFilters();

      if (JSON.stringify(this.filters) === JSON.stringify(filters)) return;

      this.filters = filters;
      await this.configureRefs();
      await this.onSearch();
    },
    removeFilterTag(tag) {
      if (tag.key === 'job_posting_id') {
        this.filters.job_posting_id = null;
        this.$refs.recruit_job_posting_select.onClear();
      }
      else if (tag.key === 'assigned') {
        this.filters.assigned = [];
        this.$refs.user_multi_select_assigned.onClearSelected();
      }
      else if (tag.key === 'status') {
        this.filters.status = null;
      }

      this.onSearch();
    },
    async configureRefs() {
      if (this.$refs.user_multi_select_assigned != null) {
        await this.$refs.user_multi_select_assigned.configure(this.filters.assigned);
      }
    },
    onSelectJobPosting(jobPostingId) {
      this.filters.job_posting_id = jobPostingId;
    },
    onSelectUserAssigned(users) {
      this.filters.assigned = users.map(item => { return item.id; });
    },
    onRemove(row) {
      if (!this.canEditRecruitJobPostings()) return;

      if (row.item) {
        this.deleteRow = row.item
      }

      const title = "Удаление отклика";
      const message = `Вы действительно хотите отклик №${this.deleteRow.id}?`;
      this.showModalDelete(title, message, async () => {
        const result = await this.deleteResponse(this.deleteRow);

        if (result.error) {
          this.showToast('Ошибка при удалении.', 'Ошибка', 'danger');
        } else {
          this.showToast('Отклик удалён.', 'Успех', 'success');
          await this.getItems();
        }
      });
    },
    // Permissions
    canEditRecruitJobPostings() {
      return this.hasPermission([PERM.RECRUIT_JOB_POSTING_EDIT]);
    },
    canEditRecruitTasks() {
      return this.hasPermission([PERM.RECRUIT_TASK_EDIT]);
    },
    canEditWorkers() {
      return this.hasPermission([PERM.WORKER_EDIT]);
    }
  },
}
</script>

<style>
.jobPostingResponsesAction {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}

#job-posting-responses td {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/Recruiting/JobPostingResponses.vue